const mobileMenuWrapper = document.getElementById("mobileMenuWrapper")

const mobileMenu = document.getElementById("mobileMenu")

const openButton = document.getElementById("openMobileMenu")

const closeButton = document.getElementById("closeMobileMenu")

function toggleMenu(e) {
  let insideMenu = e.target.closest("#mobileMenu") ? true : false
  let insideCloseButton = e.target.closest("#closeMobileMenu") ? true : false
  let shouldToggle = false
  if (insideMenu && insideCloseButton) {
    shouldToggle = true
  } else if (!insideMenu) {
    shouldToggle = true
  }
  if (shouldToggle) {
    mobileMenuWrapper.classList.toggle("mobile-menu-collapsed")
  }
}

mobileMenuWrapper.addEventListener("click", (e) => toggleMenu(e))

openButton.addEventListener("click", (e) => toggleMenu(e))

const expandButtons = document.querySelectorAll(
  "#mobileMenu .has-sub-menu .expand-button",
)

function expandMenu(e) {
  const li = e.target.closest(".has-sub-menu")
  li.classList.toggle("expanded")
}

expandButtons.forEach(function (button) {
  button.addEventListener("click", (e) => expandMenu(e))
})
